import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	jobFiles: {}, 				// all files belonging to job
	completedVosFiles: {}, 		// signed vos file belonging to job
	otherFiles: {}, 			// all files other than signed vos file belonging to job
	deleteFile: {}, 			// temporarily hold selected file to delete
	canUploadFile: false,
}

const getters = {
	// determine to show uploaded signed_vos files or not
	showVos(state){
		var show = false;
		_.forEach(state.jobFiles, function(key) {
			if(key.signed_vos == 1){
				show = true;
			}
		});

		return show;
	}
}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	SET_JOB_FILES(state, {files}){
		state.jobFiles = files;
	},

	SET_COMPLETED_VOS_FILES(state, {files}){
		state.completedVosFiles = files;
	},

	SET_OTHER_FILES(state, {files}){
		state.otherFiles = files;
	},

	SET_DELETE_FILE(state, {files}){
		state.deleteFile = files;
	},

	ADD_UPLOADED_FILE(state, {files}){
		state.completedVosFiles.push(files);
		state.jobFiles.push(files);
	}
}

// actions
const actions = {
	toggleBooleanState({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	// get files belonging to request
	getFiles({commit, state, dispatch, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var client_request_id = rootState.requests.formData[0].client_request_id;
		var url = rootState.auth.l+'v1/request-files?client_request_id='+client_request_id;

		axios.get(url,header)
			.then(response => {
				var files = response.data.data;
				commit('SET_JOB_FILES', {files: files});  // all files belonging to a job

				var vosFiles = files.filter( item => item.signed_vos == 1);
				commit('SET_COMPLETED_VOS_FILES', {files: vosFiles}); // completed vos files belonging to a job

				var otherFiles = files.filter( item => item.signed_vos != 1);
				commit('SET_OTHER_FILES', {files: otherFiles}); // other than completed vos files belonging to a job
			}).catch((error) => {
				console.log(error);
			});
	},

	// upload Completed VOS
	uploadFile({commit, state, dispatch, getters, rootState, rootGetters}, file){
		var header = {
			...rootState.auth.header,
			headers: { ...(rootState.auth.header.headers || {}), 'Content-Type': 'multipart/form-data' },
		};
		var request = rootState.requests.formData[0];

		let formData = new FormData();
		formData.append('file', file);
		formData.append('client_request_id', request.client_request_id);

		var url = rootState.auth.l+'v1/vos-file-upload';

		axios.post(url,formData,header)
		.then(response => {
			// show file successfull upload modal
            VueStore.dispatch('notify/setShowMessage', {key: 'showUploadFileSuccess', bool: true});
			
			// append new file to completed vos list
			var newFile = response.data.data;
			//console.log(newFile);
			commit('ADD_UPLOADED_FILE', {files: newFile});

		}).catch((error) => {
			console.log(error);
		});

	},

	// push selected file to delete to vuex
	pushToFileDelete({commit, state, dispatch, getters, rootState, rootGetters}, id){
		var files = state.jobFiles; // this will contain all files

		// filter by id
		var fileToDelete = files.filter( item => item.id == id);
		commit('SET_DELETE_FILE', {files: fileToDelete});
	},

	// delete vos file
	deleteFile({commit, state, dispatch, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var deleteFile = state.deleteFile[0];
		var id = deleteFile.id;

		var dataForServer = {
			'id': id,
			'client_request_id': deleteFile.client_request_id
		};

		// update the server
		var url = rootState.auth.l+'v1/delete-vos-files/'+id;
		axios.post(url,dataForServer,header)
		.then(response => {
            // show modal for successful deletion
            VueStore.dispatch('notify/setShowMessage', {key: 'showDeleteFileSuccess', bool: true});

            // find id of the file and remove from vuex 
			var completedVosFiles = state.completedVosFiles;
			var updatedCompletedvosFiles = completedVosFiles.filter( item => item.id != id);
			commit('SET_COMPLETED_VOS_FILES', {files: updatedCompletedvosFiles}); 	// removed the selected id to be delete and reset state variable.

			// remove the deleted id from all job files
			var jobFiles = state.jobFiles;
			var updatedJobFiles = jobFiles.filter( item => item.id != id);
			commit('SET_JOB_FILES', {files: updatedJobFiles});  // all files belonging to a job
		}).catch((error) => {
			console.log(error);
		});
	},
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}